import { getProjectId, postProjectId, deleteProjectById, getProjectIdById } from "./template_crud";

const welding = '/welding'
export const getWeldingLogList = getProjectId(welding)
export const addWeldingLogOne = postProjectId(welding)
export const deleteWeldingLogById = deleteProjectById(welding)

export const getWeldingLogIdList = {
  path: (obj) => `/projects/${obj.idProject}${welding}/${obj.id}`,
  type: 'GET'
}
export const getWeldingLogIdPrint = {
  path: (obj) => `/projects/${obj.idProject}${welding}/${obj.id}/print`,
  type: 'GET'
}
export const addWeldingLogIdOne = {
  path: (obj) => `/projects/${obj.idProject}${welding}/${obj.id}`,
  type: 'POST'
}
export const deleteWeldingLogIdById = (id, weldingId) => ({
  path: (obj) => `/projects/${id}${welding}/${weldingId}/${obj.id}`,
  type: 'DELETE'
})


const welders = welding + '/welders'
export const getWeldersList = getProjectId(welders)
export const addWeldersOne = postProjectId(welders)
export const getWeldersById = getProjectIdById(welders)
export const deleteWeldersById = deleteProjectById(welders)

const weldersEngineer = welding + '/welders_engineer'
export const getWeldersEngineerList = getProjectId(weldersEngineer)
export const addWeldersEngineerOne = postProjectId(weldersEngineer)
export const getWeldersEngineerById = getProjectIdById(weldersEngineer)
export const deleteWeldersEngineerById = deleteProjectById(weldersEngineer)